const initPoints = () => {
  const keyObj = {}
  const keyArray = ['ONE', 'TWO', 'ALL']

  for (let i = 1; i <= 6; i++) {
    for (let k = 0; k < 3; k++) {
      keyObj[`YXX:EQUAL:${i}:${keyArray[k]}`] = {
        mainKey: 'points',
        supKey: '',
        groupKey: `YXX:EQUAL:${i}:${keyArray[k]}`
      }
    }
  }

  return keyObj
}

const initPair = () => {
  const keyObj = {}

  for (let i = 1; i <= 6; i++) {
    const groupKey = `${i}:PAIR`
    keyObj[groupKey] = {
      mainKey: 'pair',
      supKey: '',
      groupKey
    }
  }

  return keyObj
}

const initAllMatch = () => {
  const keyObj = {}

  for (let i = 1; i <= 6; i++) {
    const groupKey = `${i}:TRIPLE`
    keyObj[groupKey] = {
      mainKey: 'all_match',
      supKey: '',
      groupKey
    }
  }

  return keyObj
}

const initAllMatchAllSelect = () => {
  const keyObj = {
    'ANY:TRIPLE': {
      mainKey: 'all_match_all_select',
      supKey: '',
      groupKey: 'ANY:TRIPLE'
    }
  }

  return keyObj
}

const initSumOfValue = () => {
  const mainKey = 'sum'
  const overUnderKey = groupKey => {
    return {
      mainKey,
      supKey: 'two_side',
      groupKey
    }
  }
  const keyObj = {
    'ALL:SUM:OVER': overUnderKey('ALL:SUM:OVER'),
    'ALL:SUM:UNDER': overUnderKey('ALL:SUM:UNDER'),
    'ALL:SUM:ODD': overUnderKey('ALL:SUM:ODD'),
    'ALL:SUM:EVEN': overUnderKey('ALL:SUM:EVEN')
  }

  for (let i = 4; i <= 17; i++) {
    const groupKey = `ALL:SUM:${i}`
    keyObj[groupKey] = {
      mainKey,
      supKey: 'sum',
      groupKey
    }
  }

  return keyObj
}

const initSelectColor = () => {
  const mainKey = 'select_color'
  const colorArray = ['RED', 'GREEN', 'BLUE']
  const number = ['one', 'two', 'three']

  const keyObj = {
    'ANY:COLOR': {
      mainKey,
      supKey: 'any_three_color',
      groupKey: 'ANY:COLOR'
    }
  }

  for (let i = 1; i <= 3; i++) {
    for (let k = 1; k <= 3; k++) {
      keyObj[`${i}:COLOR:${colorArray[k - 1]}`] = {
        mainKey,
        supKey: `${number[i - 1]}_color`,
        groupKey: `${i}:COLOR:${colorArray[k - 1]}`
      }
    }
  }

  return keyObj
}

export default {
  ...initPoints(),
  ...initPair(),
  ...initAllMatch(),
  ...initAllMatchAllSelect(),
  ...initSumOfValue(),
  ...initSelectColor()
}
